import React, { useEffect,useState } from 'react';
import ScrollAnimation from "react-animate-on-scroll";
import {  Container , Row, Col } from "react-bootstrap";
import "./HomeIntro.scss";
import PlayVideo from '../../../Components/Play/PlayVideo';
import ReactMarkdown from "react-markdown"
import GetURL from '@Components/common/site/get-url';
import { getSrc } from "gatsby-plugin-image"
// import CustomVideoPlay from "@Components/CustomVideo/CustomVideo.js";
import Slider from "react-slick";
import { inViewOptions } from '../../utils/animations';
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";

const containerVariants = {
    hidden: {
        opacity: 0
    },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.4,
            ease: [0.33, 1, 0.68, 1],
            duration: 0.4
        }
    }
}

const titleVariants = {
    hidden: {
        opacity: 0,
        y: 40
    },
    visible: {
        opacity: 1,
        y: 0,
        delay: 1.5,
        transition: {
            ease: [0.33, 1, 0.68, 1],
            duration: 1
        }
    }
}

const contentVariants = {
    hidden: {
        opacity: 0,
        y: 40
    },
    visible: {
        opacity: 1,
        y: 0,
        delay: 2,
        transition: {
            ease: [0.33, 1, 0.68, 1],
            duration: 1
        }
    }
}

const HomeIntro = (props) => {

    const [isPlay, setPlay] = useState(false);
    const settings = {
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots:true,
            },
          },
        ],
      }
      const [renderComponent, setRenderComponent] = useState(false);
      useEffect(() => {
        window.addEventListener("mousemove", () => {
          if (renderComponent === false) {
            setRenderComponent(true)
          }
          })
          window.addEventListener("touchmove", () => {
              if (renderComponent === false) {
              setRenderComponent(true)
              }
          })
          window.addEventListener("keypress", () => {
              if (renderComponent === false) {
              setRenderComponent(true)
              }
          })
      }, [])
    return (
        <InView {...inViewOptions}>
            {({ ref, inView }) => {
                return (
                    <motion.section
                        ref={ref}
                        initial="hidden"
                        animate={inView ? "visible" : "hidden"}
                        variants={containerVariants}
                    >
                        <React.Fragment>
                            <section className="home-intro">
                                <Container>
                                    <Row>
                                        <Col lg={4} xl={5}>
                                            <ScrollAnimation animateIn='fadeInUp' animateOnce={true}>
                                                <motion.div variants={titleVariants}>
                                                    <div className="video">
                                                        <div className="video-img">
                                                            <div className="img-wrapper-video">                                                       
                                                                {renderComponent && <img src={getSrc(props.Person_Image?.url_sharp)} alt={props.Person_Image?.alternativeText} /> }
                                                            </div>
                                                            {/* {props.Video_Url &&
                                                                <CustomVideoPlay title={"Intro"} url={props.Video_Url} />
                                                            } */}
                                                        </div>
                                                    </div>
                                                    <h2>{props.Title} <span className="stroke-text">{props.Title1}</span> {props.Title2}</h2>
                                                    <GetURL class="btn btn-primary d-none d-md-inline-flex" label={props.Cta?.CTA_1_Label} alias={props.Cta?.CTA_1_Url?.Alias} />
                                                </motion.div>
                                            </ScrollAnimation>
                                        </Col>
                                        <Col lg={8} xl={7}>
                                            <motion.div variants={contentVariants}>
                                                <div className="mobile-view-only">
                                                <div className="home-intro-content">
                                                <Slider {...settings}>
                                                    {props.Add_Cta?.map((item, index) => (
                                                        <div className={index % 2 ? "home-intro-content-block p-left" : "home-intro-content-block"}>
                                                            <ScrollAnimation animateIn='fadeInUp' animateOnce={true}>
                                                                <div className="home-intro-icon"><img src={item.Icon?.url} alt={item.Icon?.alternativeText} width={24} height={20}/></div>
                                                                <div className="home-intro-content-inner">
                                                                    <h6>{item?.Title}</h6>
                                                                    <ReactMarkdown source={item?.Content} allowDangerousHtml />
                                                                    <GetURL class="text-link" label={item.CTA_label} alias={item?.CTA_Url?.Alias} />
                                                                </div>
                                                            </ScrollAnimation>
                                                        </div>
                                                    ))}
                                                    </Slider>
                                                    </div>
                                                    </div>
                                                    <div className="non-mobile-view-only">
                                                    <div className="home-intro-content">
                                                    {props.Add_Cta?.map((item, index) => (
                                                        <div className={index % 2 ? "home-intro-content-block p-left" : "home-intro-content-block"}>
                                                            <ScrollAnimation animateIn='fadeInUp' animateOnce={true}>
                                                                <div className="home-intro-icon"><img src={item.Icon?.url} alt={item.Icon?.alternativeText} width={24} height={20} /></div>
                                                                <div className="home-intro-content-inner">
                                                                    <h6>{item?.Title}</h6>
                                                                    <ReactMarkdown source={item?.Content} allowDangerousHtml />
                                                                    <GetURL class="text-link" label={item.CTA_label} alias={item?.CTA_Url?.Alias} />
                                                                </div>
                                                            </ScrollAnimation>
                                                        </div>
                                                    ))}
                                                    </div>
                                                    </div>
                                                
                                            </motion.div>
                                        </Col>
                                    </Row>
                                </Container>
                                <PlayVideo
                                    isOpen={isPlay}
                                    isCloseFunction={setPlay}
                                    videoId="V8ksSGxo6no"
                                    isAutoPlay={1}
                                />
                            </section>
                        </React.Fragment>
                    </motion.section>
                )
            }}
        </InView>
    )
}

export default HomeIntro;